import Formatter from 'accounting'

export default (number, props) => {
  if (number === '') {
    return number
  }
  return Formatter.formatNumber(number, {
    precision: props.precision,
    decimal: props.decimal,
    thousand: props.thousand,
  })
}
